export default __webpack_public_path__ + "static/media/arrowRightIcon.d9022f2f.svg";